export default __webpack_public_path__ + "static/media/rest_placeholder.c06c85ff.png";